/**
 * クラス名：板金の装置設定のジョイント画面
 * 作成者：チュー
 * 作成日：2023/06/21
 * バージョン：1.0
 */
import { Row, Col, Input, Button, Space, Popover } from 'antd';
import React, { useEffect, forwardRef, useState, useRef } from 'react';
import { Table } from 'react-bootstrap';
import { PlusCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { isEmpty } from '@rc-component/mini-decimal/es/numberUtil';
import { commonModal } from '../../../common/CommonModal';
import {
  deleteListColData,
  updateListColData,
  sortListData,
  handleKeyPress,
  updateList,
  sortListByMasterData,
  getInputBorderStyle,
  regexExp,
  toHalfWidth,
  isDigitZenkaku,
  isDigit,
} from '../../../common/Common';

const Device_Blank_Joint = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);

  const [isItaatsu, setIsItaatsu] = useState(false);
  const [isSize, setIsSize] = useState(false);

  // 板厚
  const [itaatsuTemp, setItaatsuTemp] = useState([]);
  const [itaatsuData, setItaatsuData] = useState([]);
  const [jointItaatsuList, setJointItaatsuList] = useState([]);
  // const [gasTypeList, setGasTypeList] = useState([]);
  // const [kakousokudoItaatsuList, setKakousokudoItaatsuList] = useState([]);
  // const [piercingProcessList, setPiercingProcessList] = useState([]);
  // const [punchProcessItaatsuListData, setPunchProcessItaatsuListData] = useState([]);

  // const [listData, setListData] = useState([]);

  // サイズ
  const [size, setSize] = useState([]);
  const [sizeTemp, setSizeTemp] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [materialType, setMaterialType] = useState([]);

  const [filterKeys, setFilterKeys] = useState([]);

  const [errIndexVal, setErrIndexVal] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef([]);
  useEffect(() => {
    setErrIndexVal([]);
    setErrorMessage('');
    setEditMode(props.editMode);

    if (props?.detailsData?.jointSeparateThickThMaster) {
      setItaatsuData(props?.detailsData?.jointSeparateThickThMaster);
      setItaatsuTemp(props?.detailsData?.jointSeparateThickThMaster);
    }
    if (props?.detailsData?.jointSeparateItems) {
      const items = props?.detailsData?.jointSeparateItems || {};
      const firstKey = Object.keys(items)[0];
      const firstRow = items[firstKey];
      setJointItaatsuList(firstRow);
    }

    // setGasTypeList(props.gasTypeList);
    // setKakousokudoItaatsuList(props.kakouSokudoItaatsuList);
    // setPiercingProcessList(props.piercingProcessList);
    // setListData(props.blankKakousokudolistData);
    // setPunchProcessItaatsuListData(props.punchProcessItaatsuListData);

    if (props?.detailsData?.jointQtySizeThMaster) {
      setSize(props?.detailsData?.jointQtySizeThMaster);
      setSizeTemp(props?.detailsData?.jointQtySizeThMaster);
    }
    if (props?.detailsData?.jointQtyItems) {
      setSizeList(props?.detailsData?.jointQtyItems);
    }

    setMaterialType(props.materialTypes);
    const usedItems = props.materialTypes?.filter((item) => item.info.isUsed);

    // Extract the id values from the filtered items
    const usedIds = usedItems?.map((item) => item.id);
    setFilterKeys(usedIds);
  }, [
    props.detailsData,
    props.editMode,
    props.materialTypes,
    // props.kakouSokudoItaatsuList,
    // props.itaatsuData,
    // props.jointItaatsuList,
    // props.gasTypeList,
    // props.piercingProcessList,
    // props.jointSizeMaster,
    // props.jointSizeList,
    // props.blankKakousokudolistData,
  ]);

  const addItaatsuModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>板厚</p>
    </div>
  );
  const addSizeModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>
        cm<sup>2</sup>
      </p>
    </div>
  );
  const addData = () => {
    setIsUpdateData(true);
  };

  const closeAddModal = () => {
    if (isItaatsu === true) {
      setItaatsuTemp(itaatsuData);
      setIsItaatsu(false);
    } else if (isSize === true) {
      setSizeTemp(size);
      setIsSize(false);
    }
  };
  const addItaatsu = (id, index) => {
    inputRef.current[index].focus();
    const copyData = itaatsuTemp.slice(); // Create a copy of the original array

    const insertIndex = itaatsuTemp?.findIndex((item) => item.no === id); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: itaatsuTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setItaatsuTemp(copyData);
    }
  };
  const addSize = (id, index) => {
    inputRef.current[index].focus();
    const copyData = sizeTemp.slice(); // Create a copy of the original array

    const insertIndex = sizeTemp?.findIndex((item) => item.no === id); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: sizeTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setSizeTemp(copyData);
    }
  };
  const deleteItaatsu = (id, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (itaatsuTemp?.filter((item) => item.isOutOfRange === false)?.length > 2) {
      const updatedData = itaatsuTemp?.map((row) => {
        if (row.no === id) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setItaatsuTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };
  const deleteSize = (id, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (sizeTemp?.filter((item) => item.isOutOfRange === false)?.length > 2) {
      const updatedData = sizeTemp?.map((row) => {
        if (row.no === id) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setSizeTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };
  const handleItaatsuChange = (event, id, field) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    const updatedData = itaatsuTemp?.map((row) => {
      if (row.no === id) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    setItaatsuTemp(updatedData);
  };
  const handleSizeChange = (event, id, field) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    const updatedData = sizeTemp?.map((row) => {
      if (row.no === id) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    setSizeTemp(updatedData);
  };
  const cancelMasterData = () => {
    if (isItaatsu === true) {
      setItaatsuTemp(itaatsuData);
      setIsItaatsu(false);
    } else if (isSize === true) {
      setSizeTemp(size);
      setIsSize(false);
    }
  };
  // const updateListData = (deletedData, newId) => {
  //   const list = [
  //     { key: 1, name: '丸穴径', svalue: '', mvalue: '', lvalue: '' },
  //     { key: 2, name: '加工周長', svalue: '', mvalue: '', lvalue: '' },
  //     { key: 3, name: '速度', svalue: '', mvalue: '', lvalue: '' },
  //   ];
  //   const updatedData = deletedData?.map((item) => {
  //     newId?.forEach((key) => {
  //       // Add new objects to lstData
  //       item.lstData.push({
  //         key: key,
  //         value: '',
  //         list: list,
  //       });
  //     });

  //     return item;
  //   });
  //   return updatedData;
  // };
  const addItaatsuMaster = () => {
    setIsItaatsu(false);

    const deletedId = [];

    itaatsuData?.forEach((item1, index) => {
      const found = itaatsuTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange === true);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = itaatsuTemp
      ?.filter((item) => !item.isOutOfRange && !itaatsuData.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    // const deletedData = deleteListColData(jointItaatsuList, deletedId);
    // const deletedData2 = deleteListColData(gasTypeList, deletedId);
    // const deleteData3 = deleteListColData(kakousokudoItaatsuList, deletedId);
    // const deleteData4 = deleteListColData(piercingProcessList, deletedId);
    // const deleteData5 = deleteListColData(punchProcessItaatsuListData, deletedId);
    // const deleteData6 = deleteListColData(listData, deletedId);

    // const updatedData = updateListColData(deletedData, newId);
    // const updatedData2 = updateListColData(deletedData2, newId);
    // const updatedData3 = updateListColData(deleteData3, newId);
    // const updatedData4 = updateListColData(deleteData4, newId);
    // const updatedData5 = updateListColData(deleteData5, newId);
    // const updatedData6 = updateListData(deleteData6, newId);

    // const sortedList = sortListData(updatedData, itaatsuTemp);
    // const sortedList2 = sortListData(updatedData2, itaatsuTemp);
    // const sortedList3 = sortListData(updatedData3, itaatsuTemp);
    // const sortedList4 = sortListData(updatedData4, itaatsuTemp);
    // const sortedList5 = sortListData(updatedData5, itaatsuTemp);
    // const sortedList6 = sortListData(updatedData6, itaatsuTemp);

    // const updatedList = updateList(jointItaatsuList, deletedId, newId);
    const updatedList = updateList(props?.detailsData?.jointSeparateItems, deletedId, newId);

    const sortedList = sortListByMasterData(updatedList, itaatsuTemp);

    setItaatsuData(itaatsuTemp);

    const items = sortedList || {};
    const firstKey = Object.keys(items)[0];
    const firstRow = items[firstKey];
    setJointItaatsuList(firstRow);
    props.updatedItaatsuData(itaatsuTemp);

    props.updatedJointItaatsuList(firstRow);

    // setGasTypeList(sortedList2);
    // props.updatedGasTypeList(sortedList2);
    // setKakousokudoItaatsuList(sortedList3);
    // props.updateblankKakouSokudoItaatsuList(sortedList3);

    // setPiercingProcessList(sortedList4);
    // props.updatePiercingProcessList(sortedList4);
    // setPunchProcessItaatsuListData(sortedList5);
    // props.updatePunchProcessList(sortedList5);

    // setListData(sortedList6);
    // props.updatedBlankKakousokudolistData(sortedList6);
  };
  const addSizeMaster = () => {
    setIsSize(false);

    const deletedId = [];

    size?.forEach((item1, index) => {
      const found = sizeTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange === true);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = sizeTemp
      ?.filter((item) => !item.isOutOfRange && !size.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    const deletedData = deleteListColData(sizeList, deletedId);

    const updatedData = updateListColData(deletedData, newId);

    const sortedList = sortListData(updatedData, sizeTemp);
    setSize(sizeTemp);
    props.updateJointQtySizeThMaster(sizeTemp);
    setSizeList(sortedList);
    props.updateJointQtyItems(sortedList);
  };
  const isValueOrderCorrect = (e, no, field, tblName) => {
    let temp = [];
    if (tblName === 'size') {
      temp = sizeTemp?.filter((i) => i.isOutOfRange === false);
    } else {
      temp = itaatsuTemp?.filter((i) => i.isOutOfRange === false);
    }
    const insertIndex = temp?.findIndex((item) => item.no === no);
    if (regexExp.test(temp[insertIndex].value) && !isDigitZenkaku(temp[insertIndex].value)) return;
    // IQX_WEBEST-220の対応-START
    if (regexExp.test(temp[insertIndex].value)) {
      // 全角の場合、
      temp[insertIndex].value = toHalfWidth(temp[insertIndex].value); // 半角へ変換
      e.target.value = temp[insertIndex].value;
      tblName === 'itaatsu' ? handleItaatsuChange(e, no, field) : handleSizeChange(e, no, field);
    }
    if (isNaN(parseFloat(temp[insertIndex].value))) {
      setErrIndexVal([...errIndexVal, insertIndex]);
      setErrorMessage('数字値を入力してください！');
      return;
    }
    // IQX_WEBEST-220の対応-END

    if (insertIndex > 0) {
      const prevValue = parseFloat(temp[insertIndex - 1].value);
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);
      if (currentValue > prevValue && currentValue < nextValue) {
        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex && item != insertIndex - 1));

        setErrorMessage('前のしきい値より大きい値を入力してください！');
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);

        if (currentValue <= prevValue) {
          setErrorMessage('前のしきい値より大きい値を入力してください！');
        } else if (currentValue >= nextValue) {
          setErrorMessage('次のしきい値より小さい値を入力してください！');
        }
      }
    } else {
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);

      if (currentValue < nextValue) {
        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex));
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);
        setErrorMessage('次のしきい値より小さい値を入力してください！');
      }
    }
  };
  const addContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {itaatsuTemp
                  ?.filter((subitem) => subitem.isOutOfRange === false)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleItaatsuChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'itaatsu')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'itaatsu')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, itaatsuTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addItaatsu(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteItaatsu(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={addItaatsuMaster}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );
  const addSizeContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>値</label>
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {sizeTemp
                  ?.filter((subitem) => subitem.isOutOfRange === false)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleSizeChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'size')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'size')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, sizeTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addSize(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteSize(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'} id="update" onClick={addSizeMaster}>
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );
  const itaatsuModal = () => {
    setIsItaatsu(true);
    setErrIndexVal([]);
    setErrorMessage('');
  };
  const sizeModal = () => {
    setIsSize(true);
    setErrIndexVal([]);
    setErrorMessage('');
  };
  const jointItaatsuListDataChange = (event, key, no) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    const newList = jointItaatsuList;
    const itemIndex = newList?.findIndex((item) => item.no === no);

    if (itemIndex !== -1) {
      newList[itemIndex].value = event;
      setJointItaatsuList(newList);
      props.updatedJointItaatsuList(newList);
    }
  };
  const jointItaatsuListDataChangeBlur = (event, key, no) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    const newList = jointItaatsuList;
    const itemIndex = newList?.findIndex((item) => item.no === no);

    if (itemIndex !== -1) {
      event = regexExp.test(event) ? toHalfWidth(event) : event;
      newList[itemIndex].value = parseInt(event) || 0;
      setJointItaatsuList(newList);
      props.updatedJointItaatsuList(newList);
    }
  };
  const jointSizeListDataChange = (event, no) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    sizeList
      ?.filter((item) => item.no === no)
      ?.map((list) => {
        list.value = event;
      });
    setSizeList(sizeList);
    props.updateJointQtyItems(sizeList);
  };

  const jointSizeListDataChangeBlur = (event, no) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    sizeList
      ?.filter((item) => item.no === no)
      ?.map((list) => {
        event = regexExp.test(event) ? toHalfWidth(event) : event;
        list.value = parseInt(event) || 0;
      });
    setSizeList(sizeList);
    props.updateJointQtyItems(sizeList);
  };

  return (
    <>
      <div style={{ marginLeft: 10, marginRight: 10 }}>
        <Row className="table-container">
          <Table
            style={{
              width:
                itaatsuData?.filter((i) => i.isOutOfRange === false)?.length > 8
                  ? '100%'
                  : itaatsuData?.filter((i) => i.isOutOfRange === true)?.length * 98 + 196 + 'px',
            }}
          >
            {/* <tr style={{ textAlign: 'center' }}>
              <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                <Row justify="center" className="ant-row-no-bg-color">
                  <Space>
                    <label>材質区分</label>
                    <label>/</label>
                    {editMode ? (
                      <>
                        <Button className="cancleButton" onClick={itaatsuModal} style={{ pointerEvents: 'auto' }}>
                          板厚
                        </Button>
                      </>
                    ) : (
                      <>
                        <label>板厚</label>
                      </>
                    )}
                  </Space>
                </Row>
              </td>

              {itaatsuData
                ?.filter((subitem) => subitem.isOutOfRange === false)
                ?.map((item, index) => (
                  <td key={index} style={{ width: '98px' }} className="param-tbl-header">
                    ～{item.value}t
                  </td>
                ))}
            </tr> */}
            {/* {Object.keys(jointItaatsuList)
              ?.filter((listkey) => filterKeys?.includes(parseInt(listkey)))
              ?.map((key) => (
                <tr key={key} style={{ textAlign: 'center' }}>
                  <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                    {materialType?.find((item) => item.id.toString() === key)?.name}
                  </td>
                  {jointItaatsuList[key]?.map((item, index) => (
                    <td key={index} style={{ verticalAlign: 'middle', textAlign: 'center', width: 210 }}>
                      <Input
                        value={item.value}
                        onChange={(e) => jointItaatsuListDataChange(e.target.value, key, item.no)}
                        onBlur={(e) => jointItaatsuListDataChangeBlur(e.target.value, key, item.no)}
                        onPressEnter={(e) => jointItaatsuListDataChangeBlur(e.target.value, key, item.no)}
                        onKeyPress={(e) => {
                          handleKeyPress(e, false);
                        }}
                        style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                        className={editMode ? 'input-editable ' : 'input-non-editable'}
                      />
                    </td>
                  ))}
                </tr>
              ))} */}

            <tr style={{ textAlign: 'center' }}>
              <td rowSpan={2} style={{ width: '196px' }} className="fixedOneRowCol">
                ジョイントバラシ(秒/個)
              </td>
              <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                <Row justify="center" className="ant-row-no-bg-color">
                  <Space>
                    {editMode ? (
                      <>
                        <Button className="cancleButton" onClick={itaatsuModal} style={{ pointerEvents: 'auto' }}>
                          板厚t(mm)
                        </Button>
                      </>
                    ) : (
                      <>
                        <label>板厚t(mm)</label>
                      </>
                    )}
                  </Space>
                </Row>
              </td>

              {itaatsuData
                ?.filter((subitem) => subitem.isOutOfRange === false)
                ?.map((item, index) => (
                  <td key={index} style={{ width: '98px' }} className="param-tbl-header">
                    ～{item.value}mm
                  </td>
                ))}
            </tr>
            <tr style={{ textAlign: 'center' }}>
              <td style={{ width: '196px' }} className="fixedOneRowCol">
                秒数
              </td>
              {jointItaatsuList?.map((item, index) => (
                <td key={index} style={{ verticalAlign: 'middle', textAlign: 'center', width: 210 }}>
                  <Input
                    value={item.value}
                    onChange={(e) => jointItaatsuListDataChange(e.target.value, 0, item.no)}
                    onBlur={(e) => jointItaatsuListDataChangeBlur(e.target.value, 0, item.no)}
                    onPressEnter={(e) => jointItaatsuListDataChangeBlur(e.target.value, 0, item.no)}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                    style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                    className={editMode ? 'input-editable ' : 'input-non-editable'}
                  />
                </td>
              ))}
            </tr>
          </Table>
        </Row>
        <Row className="table-container">
          <Table
            style={{
              width:
                size?.filter((i) => i.isOutOfRange === false)?.length > 8
                  ? '100%'
                  : size?.filter((i) => i.isOutOfRange === false)?.length * 98 + 196 + 'px',
            }}
          >
            <tr style={{ textAlign: 'center' }}>
              <td rowSpan={2} style={{ width: '196px' }} className="fixedOneRowCol">
                ジョイント個数
              </td>
              <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                <Row justify="center" className="ant-row-no-bg-color">
                  <Space>
                    {editMode ? (
                      <>
                        <Button className="cancleButton" onClick={sizeModal} style={{ pointerEvents: 'auto' }}>
                          面積(cm<sup>2</sup>)
                        </Button>
                      </>
                    ) : (
                      <>
                        <label>
                          面積(cm<sup>2</sup>)
                        </label>
                      </>
                    )}
                  </Space>
                </Row>
              </td>

              {size
                ?.filter((subitem) => subitem.isOutOfRange === false)
                ?.map((item, index) => (
                  <td key={index} style={{ width: '98px' }} className="param-tbl-header">
                    ～{item.value}cm<sup className="param-tbl-header">2</sup>
                  </td>
                ))}
            </tr>

            <tr style={{ textAlign: 'center' }}>
              <td style={{ width: '196px' }} className="fixedOneRowCol">
                個数
              </td>
              {sizeList?.map((row, index) => (
                <td key={index} style={{ width: '98px' }}>
                  <Input
                    value={row.value}
                    onChange={(e) => jointSizeListDataChange(e.target.value, row.no)}
                    onBlur={(e) => jointSizeListDataChangeBlur(e.target.value, row.no)}
                    onPressEnter={(e) => jointSizeListDataChangeBlur(e.target.value, row.no)}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                    style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                    className={editMode ? 'input-editable ' : 'input-non-editable'}
                  />
                </td>
              ))}
            </tr>
          </Table>
        </Row>
      </div>

      {/* 板厚 */}
      {isItaatsu
        ? commonModal(
            isItaatsu,
            addItaatsuModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addContent,
            null,
            null,
            true
          )
        : ''}
      {/* サイズ */}
      {isSize
        ? commonModal(
            isSize,
            addSizeModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addSizeContent,
            null,
            null,
            true
          )
        : ''}
    </>
  );
});

export default Device_Blank_Joint;
